import {btn_c_whiteToHighlight,
  btn_sm, btn_md, btn_c_lightGreen, btn_c_lightRed, btn_c_xdHighlight,
  svg_sm,
  svg_md,
  svg_inline,
  font_s_sm,
  font_s_md,
  colors,
  clearfix,
  absCenterY,
} from '@xpertdox_js/xdstyle';

const btnShared = {
  ...font_s_md,
  borderRadius: '200px',
  marginBottom: '8px',
  fontWeight: 'bold',
  textAlign: 'left',
}

export default {
  errorMsg: {
    color: colors.error
  },
  displayContainerChanged: {
    background: '#f3fefd',
  },
  property: {
    float: 'left',
    fontWeight: 'bold',
    ...font_s_md,
    width: '15%',
    position: 'relative',
    overflow: 'hidden',
    padding: '12px 2px 12px 8px'
  },
  propertyText: {
    margin: 0,
  },
  toolTipContainer: {
    padding: '4px 0'
  },
  toolTipText: {
    margin: 0,
    fontWeight: 'normal',
    ...font_s_sm,
  },
  tooltipIcon: {
    ...svg_inline,
    ...svg_sm,
    marginTop: '-1px',
    float: 'right',
  },
  value: {
    color: '#555',
    float: 'left',
    width: '85%',
    padding: '12px 4px',
    ...font_s_md,
    minHeight: 43,
  },
  valueText: {
    margin: 0,
  },
  clearButtonText: {
    display: 'inline-block',
    marginTop: '1px',
  },
}
